import Axios from 'axios';
import axios, { AxiosResponse } from 'axios';
import JwtService from 'common/jwt.service';
const URL_BASE = '/api';
let token = '';

/**
 * WebAPIを扱うためのヘルパー関数
 */
export default class ApiHelper {

    /**
     * 認証情報無し&BaseURLなしの axiosのhttpインスタンスを返す
     */
    static getNoAuthHttpWithoutBaseUrl() {
        const http = axios.create({
            //withCredentials: true
        });
        return http;
    }

    /**
     * 認証情報無しの axiosのhttpインスタンスを返す
     */
    static getNoAuthHttp() {
        const http = axios.create({
            //withCredentials: true,
            baseURL: URL_BASE
        });
        return http;
    }

    /**
     * 認証情報なしで GET
     * @param url 
     * @param params 
     */
    static async getNoAuth(url: string, params: any = {}) {
        let http = await ApiHelper.getNoAuthHttp();

        try {
            let res = await http.get(url, {
                params: params
            })
            return res.data;
        }
        catch (error) {
            console.log(error)
        }
    }

    /**
     * 認証情報なしで POST
     * @param url 
     * @param params 
     */
    static async postNoAuth(url: string, data: any) {
        let http = await ApiHelper.getNoAuthHttp();

        try {
            let res = await http.post(url, data);
            return res.data;
        }
        catch (error) {
            console.log(error)
        }
    }

    /**
     * 認証トークンを取得する。cookie認証でトークンの取得を試みて、認証エラーの場合にはログイン画面に遷移する
     */
    static async getToken() {
        try {
            const http = axios.create({
                //withCredentials: true
            });
            http.interceptors.request.use(
                (config) => config,
                async (err: any) => {
                    const error = err.response;
                    // if error is 401 
                    if (error.status === 401 || error.status === 500) {
                        window.location.href = '/Account/Logout';
                    }
                    return;
                });
            const res = await http.get('/api/SelfToken')
            token = res.data.token;
            JwtService.saveToken(token);
            JwtService.saveUserId(res.data.userId);
            JwtService.saveUserName(res.data.userName);
            JwtService.saveTantouCode(res.data.tantouCode);
            JwtService.saveLevel(res.data.level);
        }
        catch (err) {
            const error = err.response;
            console.log(error)
            if (error.status === 401 || error.status === 500) {
                window.location.href = '/Account/Logout';
            }
            return;
        }
    }

    /**
     * 認証機能つきのaxiosのHTTPインスタンスを取得する
     */
    static async getHttp() {
        const http = axios.create({
            //withCredentials: true,
            baseURL: URL_BASE
        });
        http.interceptors.request.use(async (config) => {
            if (token == '') {
                await ApiHelper.getToken();
            }
            config.headers.Authorization = `Bearer ${token}`;
            return config;
        }, async (err: any) => {
            const error = err.response;
            // if error is 401 
            if (error.status === 401 && error.config && !error.config.__isRetryRequest) {
                // request for a new token
                try {
                    await ApiHelper.getToken();
                    error.config.__isRetryRequest = true;
                    error.config.headers.Authorization = `Bearer ${token}`;
                    return http(error.config);
                }
                catch (e) {
                    console.log(e);
                }
            }
        });
        return http;
    }

    /**
     * 認証機能付きの GET
     * @param url 
     * @param params 
     */
    static async get(url: API_GET_ENDPOINT, params?: any)
    /** @deprecated このエンドポイントは存在しない可能性があります。*/
    static async get(url: string, params?: any)
    static async get(url: string, params: any = {}) {
        let http = await ApiHelper.getHttp();

        try {
            let res = await http.get(url, {
                params: params
            })
            return res.data === "" ? null : res.data
        }
        catch (e) {
            console.log(e)
            throw e;
        }
    }

    /**
     * 認証機能付きの POST
     * @param url 
     * @param data 
     */
    static async post(url: API_POST_ENDPOINT, data: any)
    /** @deprecated このエンドポイントは存在しない可能性があります。 */
    static async post(url: string, data: any)
    static async post(url: string, data: any) {
        let http = await ApiHelper.getHttp();

        try {
            let res = await http.post(url, data)
            return res.data === "" ? null : res.data
        }
        catch (e) {
            console.log(e)
            throw e;
        }
    }

    /**
     * 認証機能付きのバイナリデータGET
     * @param url 
     * @param params 
     * @typedef T 返り値の型
     * @returns axios のレスポンスをそのまま返す
     */
    static async getBinary<T = any>(url: string, params: any = {}): Promise<AxiosResponse<T>> {
        let http = await ApiHelper.getHttp();

        try {
            let res = await http.get(url, {
                responseType: 'arraybuffer',
                params: params
            })
            return res;
        }
        catch (e) {
            console.log(e)
            throw e;
        }
    }

    /**
     * content-disposition からfilenameを抜き出す
     */
    static getFileNameFromContentDisposition(disposition: string): string {
        const filenameUtf8Regex = /filename\*=UTF-8''((['"]).*?\2|[^;\n]*)/;
        const matches1 = filenameUtf8Regex.exec(disposition);
        if (matches1 != null && matches1[1]) {
            const fileName = matches1[1].replace(/['"]/g, '');
            return decodeURIComponent(fileName);
        }

        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        const matches2 = filenameRegex.exec(disposition);
        if (matches2 != null && matches2[1]) {
            const fileName = matches2[1].replace(/['"]/g, '');
            return decodeURIComponent(fileName);
        } else {
            return null;
        }
    }
}
